export const initialData = {
  // autor: '',
  codigo: '',
  descricao:'',
  indice:'',
  valor:0,
  unidade:'',
  indicador_ods: [],
}
export default initialData;
